/**
 * AbstractMixin
 */
hrd.AbstractMixin =  hrd.AbstractCommonInterface.extend({
	ignore: ['super', 'init', 'constructor'],
	init: function(ref, options){
		var defaults = {
			impl: 'hrd.AbstractMixin',
		};
		this._super($.extend({}, defaults, options));
		this.applyMixin(ref);
	},
	applyMixin: function(reference){
		if(reference) {
			let impl = this.__proto__;
			Object.keys(impl).forEach(m => {
				if(this.ignore.indexOf(m) == -1) {
					if(typeof this[m] === 'function'){
						if(reference[m] === undefined) {
							reference[m] = this[m].bind(reference);
						}
					} else {
						reference[m] = this[m];
					}
				}
			});
			if(reference.mixinSettings == undefined){
				reference.mixinSettings = [];
			}
			reference.mixinSettings.push(this.settings);
		} else {
			console.error('Try to apply a MIXIN to a non existent object')
		}
		this.reference = reference;
	}
});